module.exports = __webpack_public_path__ + "img/arrow-left-black.cf1eb533.svg";